"use client";

import React from "react";
import { Leaf, Droplets, Wind, BrickWall, Layers, Hammer, Construction, Building2, TrainFront, FileText, Download, ChevronRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const categories = [{
  id: "environment",
  title: "Environmental Engineering",
  description: "Sustainable solutions for a greener future in construction.",
  icon: <Leaf className="size-5" />,
  services: [{
    title: "Advanced Water Treatment",
    desc: "Next-gen filtration systems for industrial construction sites.",
    icon: <Droplets className="size-6 text-ring" />,
    pdfLink: "#"
  }, {
    title: "Solid Waste Management",
    desc: "Circular economy protocols for construction debris recycling.",
    icon: <Layers className="size-6 text-ring" />,
    pdfLink: "#"
  }, {
    title: "Air Quality Control",
    desc: "IoT-based monitoring systems for urban development projects.",
    icon: <Wind className="size-6 text-ring" />,
    pdfLink: "#"
  }]
}, {
  id: "materials",
  title: "Advanced Materials",
  description: "Pioneering research in high-performance construction materials.",
  icon: <BrickWall className="size-5" />,
  services: [{
    title: "Sustainable Concrete",
    desc: "Low-carbon concrete formulations with enhanced durability.",
    icon: <BrickWall className="size-6 text-ring" />,
    pdfLink: "#"
  }, {
    title: "Smart Insulation",
    desc: "Adaptive thermal materials for energy-efficient buildings.",
    icon: <Layers className="size-6 text-ring" />,
    pdfLink: "#"
  }, {
    title: "Self-Healing Materials",
    desc: "Bio-concrete technologies that repair micro-cracks autonomously.",
    icon: <Hammer className="size-6 text-ring" />,
    pdfLink: "#"
  }]
}, {
  id: "infrastructure",
  title: "Infrastructure & Transport",
  description: "Digital transformation for critical infrastructure networks.",
  icon: <Construction className="size-5" />,
  services: [{
    title: "Structural Health Monitoring",
    desc: "Real-time sensor networks for bridge and tunnel safety.",
    icon: <Construction className="size-6 text-ring" />,
    pdfLink: "#"
  }, {
    title: "Underground Engineering",
    desc: "Advanced geotechnical solutions for metro and basement works.",
    icon: <TrainFront className="size-6 text-ring" />,
    pdfLink: "#"
  }, {
    title: "Smart City Integration",
    desc: "BIM-integrated planning for connected urban infrastructure.",
    icon: <Building2 className="size-6 text-ring" />,
    pdfLink: "#"
  }]
}];
export default function ScienceAndTechnology() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}